module.exports = {"360881002":"红星街道","360881100":"厦坪镇","360881101":"龙市镇","360881102":"古城镇","360881103":"新城镇","360881104":"大陇镇","360881105":"茨坪镇","360881106":"拿山镇","360881201":"黄垇乡","360881202":"下七乡","360881203":"长坪乡","360881204":"坳里乡","360881205":"鹅岭乡","360881206":"柏露乡","360881207":"茅坪乡","360881208":"葛田乡","360881209":"荷花乡","360881210":"睦村乡","360881211":"东上乡","360881400":"井企集团","360881401":"井冈山自然保护区","360881403":"井冈山市工业园区","360881501":"白石垦殖场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/360881.json
// module id = 1316
// module chunks = 0